/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './library.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../image-library/image-library.component.ngfactory';
import * as i3 from '../../../../app/image-library/image-library.component';
import * as i4 from '../../../../app/services/client.service';
import * as i5 from '../../../../app/services/storage.service';
import * as i6 from '@angular/router';
import * as i7 from '../../../../app/services/auth.service';
import * as i8 from '../../../../app/shared/imagelibrary.service';
import * as i9 from '../../../../app/app.config';
import * as i10 from '../../../../app/front/library/library.component';
import * as i11 from '../../../../app/front/front.service';
const styles_LibraryComponent:any[] = [i0.styles];
export const RenderType_LibraryComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LibraryComponent,data:{}});
export function View_LibraryComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{itemFile:0}),i1.ɵqud(402653184,2,{itemFolder:0}),
      i1.ɵqud(402653184,3,{uploadItemModalClose:0}),i1.ɵqud(402653184,4,{newFolderModalClose:0}),
      i1.ɵqud(402653184,5,{imageLibraryModalClose:0}),(_l()(),i1.ɵeld(5,0,(null as any),
          (null as any),1,'app-image-library',([] as any[]),(null as any),(null as any),
          (null as any),i2.View_ImageLibraryComponent_0,i2.RenderType_ImageLibraryComponent)),
      i1.ɵdid(6,245760,(null as any),0,i3.ImageLibraryComponent,[i4.ClientService,
          i5.StorageService,i6.ActivatedRoute,i6.Router,i7.AuthService,i8.ImageLibraryService,
          i1.ChangeDetectorRef,i9.APP_CONFIG],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,6,0);
  },(null as any));
}
export function View_LibraryComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-library',
      ([] as any[]),(null as any),(null as any),(null as any),View_LibraryComponent_0,
      RenderType_LibraryComponent)),i1.ɵdid(1,114688,(null as any),0,i10.LibraryComponent,
      [i11.FrontService,i4.ClientService,i5.StorageService,i6.ActivatedRoute,i6.Router],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LibraryComponentNgFactory:i1.ComponentFactory<i10.LibraryComponent> = i1.ɵccf('app-library',
    i10.LibraryComponent,View_LibraryComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9saWJyYXJ5L2xpYnJhcnkuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9saWJyYXJ5L2xpYnJhcnkuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2Zyb250L2xpYnJhcnkvbGlicmFyeS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9saWJyYXJ5L2xpYnJhcnkuY29tcG9uZW50LnRzLkxpYnJhcnlDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLWltYWdlLWxpYnJhcnk+PC9hcHAtaW1hZ2UtbGlicmFyeT4iLCI8YXBwLWxpYnJhcnk+PC9hcHAtbGlicmFyeT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztzRENBQTtVQUFBO1VBQUE7YUFBQTs7NENBQUE7SUFBQTs7OztvQkNBQTtNQUFBO2lDQUFBLFVBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/front/library/library.component.ngfactory.ts